<template>
  <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0!important;">
    <div class="mt-3 pt-2" style="display: flex; justify-content: center;">
      <el-card class="box-card" style="width: 100%; max-width: 1000px">
        <div slot="header" class="clearfix">
          <div :class="layout.is_phone ? 'saomadiv_phone' : 'saomadiv'">
            <div class="saoma_left">
              <el-input type="text" v-model="checkData.code" placeholder="手动输入条形码" clearable size="small" style="width: 90%;"></el-input>
              <el-button :loading="checkload" size="small" type="primary" @click="checkFirst">查询</el-button>
            </div>
            <div class="saoma_right">
              <el-button icon="el-icon-full-screen" size="small" @click="startCameraOrStop">{{ isCameraActive ? '停止' : '扫码' }}</el-button>
              <el-button icon="el-icon-picture-outline" size="small" @click="chooseImage">图片</el-button>
            </div>
          </div>
        </div>
        <div>
          <div ref="cameraPreview" id="camera-preview" style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column;" :class="isCameraActive ? 'h400' : 'h0'"></div>
          <div class="mb-2">
            <el-tag type="warning" v-if="form.code != 1 && form.code != 0">
              <i class="el-icon-warning-outline mr-2"></i>{{form.msg}}
            </el-tag>
          </div>
          <el-form v-if="form.code != 0" :rules="rules" ref="formEdit" :model="subData" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'left' : 'left'">
            <div v-if="form.code == 1">
				<div v-if="(form.info.status==0 && form.admin_type==1) || form.info.status==1 || form.info.status==2 || (form.info.status==3 && !form.info.work_order)">
					<div>
						<el-tag style="cursor: pointer;"  class="mb-3" @click="czShow = !czShow">
							操作：<i :class="czShow?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
						</el-tag>
					</div>
					
					<div v-show="czShow">
						<el-form-item label="选择操作" prop="type" >
							<el-radio-group v-model="subData.type" size="small">
								
								<el-radio class="ml-0 mr-0" v-if="form.admin_type==1 && form.info.status==0" :label="2" border>入库</el-radio>
								<el-radio class="ml-0 mr-0" v-if="form.info.status==1" :label="3" border>出库</el-radio>
								
								<el-radio class="ml-0 mr-0" v-if="form.info.status==2" :label="4" border>使用</el-radio>
								<el-radio class="ml-0 mr-0" v-if="form.info.status==2" :label="6" border>转移</el-radio>
								<el-radio v-if="form.info.status==2" class="ml-0 mr-0" :label="8" border>回仓</el-radio>
								<el-radio v-if="form.info.status==3" class="ml-0 mr-0" :label="7" border>填写工单号</el-radio>
							</el-radio-group> 
							
							
						</el-form-item>
						<el-form-item v-if="subData.type==8" label="回仓备注" prop="remark">
							<el-input v-model="subData.remark" placeholder="回仓备注" clearable size="small" style="width: 85%;"></el-input>
						</el-form-item>
						<el-form-item v-if="subData.type==6" label="转移人员" prop="new_ins_id">
							<el-select v-model="subData.new_ins_id"  size="small" filterable placeholder="请选择" style="width: 85%;" clearable>
								</el-option>
								<el-option v-for="item in ins_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="subData.type==4" label="使用店铺" prop="shop_id">
							<el-select v-model="subData.shop_id"  size="small" filterable placeholder="请选择" style="width: 85%;" clearable>
								</el-option>
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
					    </el-form-item>
						
						<el-form-item v-if="subData.type==4" label="使用设备" prop="de_id">
							<el-select v-model="subData.de_id"  size="small" filterable placeholder="请选择" style="width: 85%;" clearable>
								</el-option>
								<el-option v-for="item in de_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item v-if="subData.type==4 || form.info.status==3" label="工单号" prop="work_order">
							<el-input v-model="subData.work_order" placeholder="工单号" clearable size="small" style="width: 85%;"></el-input>
						</el-form-item>
						
						<el-form-item v-if="subData.type==4" label="是否保固" prop="is_gu">
							<el-radio-group v-model="subData.is_gu" size="small">
								
								<el-radio class="ml-0"  :label="0" border>否</el-radio>
								<el-radio class="ml-0"  :label="1" border>是</el-radio>
								
							</el-radio-group> 
						</el-form-item>
						
						<el-form-item v-if="subData.type==4" label="是否维修" prop="is_gu">
							<el-radio-group v-model="subData.is_xiu" size="small">
								
								<el-radio class="ml-0"  :label="0" border>否</el-radio>
								<el-radio class="ml-0"  :label="1" border>是</el-radio>
								
							</el-radio-group> 
						</el-form-item>
						<el-form-item v-if="subData.type==4" label="保养配件" prop="is_bao">
							<el-radio-group v-model="subData.is_bao" size="small">
								
								<el-radio class="ml-0"  :label="0" border>否</el-radio>
								<el-radio class="ml-0"  :label="1" border>是</el-radio>
								
							</el-radio-group> 
						</el-form-item>
						
						<div class="text-center mb-3">
							<el-button type="primary" size="small" @click="submit">确 定</el-button>
						</div>
					</div>
					
					
				</div>
				
				
				
				
				  <el-tag type="success" class="mb-3">
						配件信息：
				  </el-tag>
				  <el-row>
					  
					  <el-col :span="12" :xs="12">
						  <el-form-item  label="配件图片:">
						  	  <el-image v-if="form.info.head" style="width: 30px; height: 30px" :src="form.info.head" :preview-src-list="[form.info.head]"></el-image>
						  </el-form-item>
					  </el-col>
					  <el-col :span="12" :xs="12" >
						  <el-form-item  label="配件名称:">
							  {{form.info.name}}
						  </el-form-item>
					  </el-col>
					  
					  <el-col  :span="12" :xs="12" v-if="form.info.status==3">
						  <el-form-item  label="使用设备:">
							  {{form.info.de_name}}
						  </el-form-item>
					  </el-col>
					 
					 <el-col  :span="12" :xs="12" v-if="form.info.status==3">
						  <el-form-item  label="是否保固:">
							  <span class="text-success" v-if="form.info.is_gu==1">是</span>
							  <span  v-if="form.info.is_gu==0">否</span>
						  </el-form-item>
					 </el-col>
					 <el-col  :span="12" :xs="12" v-if="form.info.status==3">
							  <el-form-item  label="是否维修:">
								  <span class="text-success" v-if="form.info.is_xiu==1">是</span>
								  <span  v-if="form.info.is_xiu==0">否</span>
							  </el-form-item>
					 </el-col>
					  
					  <el-col  :span="12" :xs="12" v-if="form.info.status==3">
							  <el-form-item  label="是否保养:">
								  <span class="text-success" v-if="form.info.is_bao==1">是</span>
								  <span  v-if="form.info.is_bao==0">否</span>
							  </el-form-item>
					  </el-col>
					  
					  <el-col :span="24" :xs="24">
						  <el-form-item  label="当前状态:">
								<span class="text-warning" v-if="form.info.status==0">待入库</span>
								<span class="text-success" v-if="form.info.status==1">已入库</span>
								<span class="text-success" v-if="form.info.status==2">维修员携带</span>
								
								<span style="color: #999;" v-if="form.info.status==3">已使用</span>
								<span style="color: #999;" v-if="form.info.status==4">调货</span>
						  </el-form-item>
					  </el-col>
				  </el-row>
				  
				  <el-tag type="success" class="mb-3">
				  		配件日志：
				  </el-tag>
				  <el-row>
					  <el-col :span="24" >
						   <el-timeline :reverse="reverse">
						      <el-timeline-item
						        v-for="(activity, index) in form.info.log"
						        :key="index"
						        :timestamp="activity.create_time">
						        {{activity.type_name}}
						      </el-timeline-item>
						    </el-timeline>
					  </el-col>
					  
				  </el-row>
				  
            </div>
          </el-form>
        </div>
        <div class="pb-3 mb-5">
          <input type="file" ref="fileInput" @change="scanImage" accept="image/*" style="display: none;">
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import Quagga from 'quagga';
import jsQR from 'jsqr';
import { commondecrypt } from '@/main';
import common from '@/common/mixins/common.js';
import buttonSearch from '@/components/common/button-search.vue';

export default {
  components: {
    buttonSearch
  },
  inject: ['layout', 'app'],
  mixins: [common],
  data() {
    return {
      rules: {
        shop_id: [{ required: true, message: "请选择使用店铺", trigger: 'blur' }],
        de_id: [{ required: true, message: "请选择使用设备", trigger: 'blur' }],
        new_ins_id: [{ required: true, message: "请选择转移维修员", trigger: 'blur' }],
      },
      checkData: {
        code: 'XCY-1-1',
        type: 2
      },
      moreInfo: false,
      chu_type: '1',
      addUrl: "data/ProLogChange", //添加/修改地址
      subData: {
        id: 0,
        type:'',
		shop_id:'',
		is_gu:0,
		is_bao:0,
		is_xiu:0,
		de_id:'',
		new_ins_id:'',
		work_order:'',
		remark:''
      },
	  reverse: false,
	          activities: [{
	            content: '活动按期开始',
	            timestamp: '2018-04-15'
	          }, {
	            content: '通过审核',
	            timestamp: '2018-04-13'
	          }, {
	            content: '创建成功',
	            timestamp: '2018-04-11'
	          }],
      form: {
        code: 0,
        msg: '',
        type: 1,
        admin_type: 0,
        info: {
            log:[]
        }
      },
     czShow:true,
      smModel: false,
      checkload: false,
	  
      isCameraActive: false,
      shop_list:[],
	  ins_list:[],
	  de_list:[],
	  v_w:316,
    };
  },
  created() {
    this.commonList('insCodeData');
  },
  mounted() {
  	this.getBoxCardWidth()
  },
  methods: {
	  getBoxCardWidth() {
	        const boxCard = document.querySelector('.box-card');
	        if (boxCard) {
	            this.v_w = boxCard.offsetWidth - 40;
	        }
	      },
    commonList(type) {
      this.layout.loading = true;
      this.axios.post('/admin/user/commonList', { type }, { token: true }).then(res => {
        let list = res.data.data.list;
       
        this.shop_list = list.shop_list;
        this.ins_list = list.ins_list;
        this.de_list = list.de_list;
        this.layout.loading = false;
      }).catch(() => {
        this.layout.loading = false;
      });
    },
   
    submit() {
      this.$refs.formEdit.validate(res => {
        if (res) {
          this.subData.id = this.form.info.id;
          this.layout.loading = true;
          this.axios.post(this.addOrEditUrl(), this.subData, { token: true }).then(res => {
            if (res.data.code == 1) {
              this.$message({ message: res.data.msg, type: 'success' });
              this.checkFirst();
			  this.layout.getPageNum();
              // if (this.subData.type == 3) {
              //   this.layout.getPageNum();
              // }
            }
            this.layout.loading = false;
          }).catch(() => {
            this.layout.loading = false;
          });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.subData.img = URL.createObjectURL(file.raw);
      let en_data = commondecrypt(res.encryption);
      res.encryption = JSON.parse(en_data);
      if (res.encryption.code == 1) {
        this.subData.head = res.encryption.data.list.url;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('文件格式错误!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    checkFirst() {
      if (!this.checkData.code) {
        this.$message({ message: '请先输入或扫描条形码', type: 'error' });
        return;
      }
      this.checkload = true;
      if (this.isCameraActive) {
        Quagga.stop();
        this.isCameraActive = false;
      }
      this.axios.post('/admin/data/checkFirst', this.checkData, { token: true }).then(res => {
		  let all = res.data
		 
		  if(all.code==1){
			  this.czShow  = true
			  this.form = all.data.list;
			  
			  this.subData.type  = this.form.info.sel_type
			 
		  }
         this.checkload = false;
      }).catch(() => {
        this.checkload = false;
      });
    },
    startCameraOrStop() {
      if (this.isCameraActive) {
        Quagga.stop();
        this.isCameraActive = false;
      } else {
        this.startCamera();
      }
    },
    startCamera() {
		console.log(this.v_w)
      Quagga.init({
        inputStream: {
          type: "LiveStream",
          target: this.$refs.cameraPreview,
          constraints: {
            width: { ideal: this.v_w },
            height: { ideal:  this.v_w  },
            aspectRatio: { ideal: 1.3333333 },
            facingMode: "environment",
			advanced: [{ zoom: 1 }] // 设置镜头倍数为最小
          }
        },
        decoder: {
          readers: ["code_128_reader"]
        },
        locate: true,
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true
        }
      }, (err) => {
        if (err) {
          console.error(err);
          return;
        }
        Quagga.start();
        this.isCameraActive = true;
        this.processQRCode();
      });
      Quagga.onDetected(this.onDetected);
    },
    processQRCode() {
      const video = this.$refs.cameraPreview.querySelector('video');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const scanQRCode = () => {
        if (!this.isCameraActive) return;
        if (video.readyState === video.HAVE_ENOUGH_DATA) {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
          const qrCode = jsQR(imageData.data, imageData.width, imageData.height);
          if (qrCode) {
            this.checkData.code = qrCode.data;
            this.playBeep();
            this.checkFirst();
            Quagga.stop();
            this.isCameraActive = false;
          } else {
            requestAnimationFrame(scanQRCode);
          }
        } else {
          requestAnimationFrame(scanQRCode);
        }
      };
      scanQRCode();
    },
    chooseImage() {
      if (this.isCameraActive) {
        Quagga.stop();
        this.isCameraActive = false;
      }
      this.$refs.fileInput.click();
    },
    scanImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.scanBarcodeOrQRCode(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
    scanBarcodeOrQRCode(src) {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const qrCode = jsQR(imageData.data, imageData.width, imageData.height);
        if (qrCode) {
          this.checkData.code = qrCode.data;
          this.playBeep();
          this.checkFirst();
        } else {
          Quagga.decodeSingle({
            src,
            numOfWorkers: 0,
            inputStream: {
              size: 800,
              singleChannel: false
            },
            decoder: {
              readers: ["code_128_reader"]
            },
            locate: true,
            debug: {
              drawBoundingBox: true,
              showFrequency: true,
              drawScanline: true,
              showPattern: true
            }
          }, (result) => {
            if (result && result.codeResult) {
              this.checkData.code = result.codeResult.code;
              this.playBeep();
              this.checkFirst();
            } else {
              this.$message({ message: '未检测到条形码或二维码', type: 'warning' });
            }
          });
        }
      };
    },
    playBeep() {
      const beep = new Audio(require('@/assets/beep.mp3')); // 根据实际路径修改
      beep.play();
    },
    onDetected(result) {
      if (result && result.codeResult) {
        this.checkData.code = result.codeResult.code;
        Quagga.stop();
        this.isCameraActive = false;
        this.playBeep();
        this.checkFirst();
      }
    }
  }
}
</script>

<style>
.codeinfo .el-form-item__label {
  color: #999;
}
.h400 {
  height: 100%;
  width: 100%;
}
.h0 {
  height: 0;
  overflow: hidden;
}
.saomadiv {
  display: flex;
  align-items: center;
}
.saoma_left {
  display: flex;
  align-items: center;
  flex: 1;
}
.saoma_right {
  display: flex;
  align-items: center;
}
.saomadiv_phone .saoma_right {
  margin-top: 20px;
}


</style>
